import React, { useState } from "react";
import styles from "./Tabs.module.scss";

interface TabbedProps {
  label: string;
  disabled?: boolean;
  children: React.ReactNode;
}

interface Props {
  heading: string;
  children: React.ReactElement<TabbedProps>[];
  onChange?: (a: string) => void;
}

const Tabs = (props: Props) => {
  const { heading, children } = props;
  const [activeTab, setActiveTab] = useState<string>(
    children.filter((x) => !x.props.disabled)[0].props.label
  );

  const onClickTabItem = (tabLabel: string) => {
    setActiveTab(tabLabel);
    if (props.onChange) {
      props.onChange(tabLabel);
    }
  };

  return (
    <div className={styles.Tabs}>
      <div className={styles.Tabs__heading}>
        <h3 className={styles.Tabs__title}>{heading}</h3>
        <ul className={styles.Tabs__navigation}>
          {children.map((child: React.ReactElement<TabbedProps>) => {
            const { label, disabled } = child.props;

            if (disabled) {
              return <React.Fragment key={`tab-item-${label}`}></React.Fragment>;
            }

            return (
              <li
                key={`tab-item-${label}`}
                className={label === activeTab ? styles.active : undefined}
                onClick={() => onClickTabItem(label)}
              >
                {label}
              </li>
            );
          })}
        </ul>
      </div>
      <div className={styles.Tabs__content}>
        {children.map((child) => {
          if (child.props.label !== activeTab || child.props.disabled)
            return undefined;
          return child.props.children;
        })}
      </div>
    </div>
  );
};

export default Tabs;
